import { Outlet } from 'react-router-dom';

/**
 * Blog Layout - No header/footer for immersive blog experience
 * Used for blog pages and post pages
 */
export const BlogLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  );
};
